/* eslint-disable */
import changeCase from 'change-object-case';
import moment from 'moment';
import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import { mapDispatch, navTo, numberWithCommas, setToken } from '../utils/util';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import FontAwesome from 'react-fontawesome';

import OzComponent from '../lib/OzComponent';
import Wrapper from './Wrapper';
import './ProBookings.css';
import WhereField from './partials/WhereField';
import LeaderboardStats from './partials/LeaderboardStats';
import RegisterForm from './partials/RegisterForm';
import CompanySignUpForm from './partials/CompanySignUpForm';
import ProBookableSlots from './partials/ProBookableSlots';
import {
  register,
  fetchUser,
  companySignUp,
} from '../actions';


class ProBookings extends OzComponent {

  static need = [
    ['user', fetchUser],
  ]

  render() {
    return (
      <Wrapper className="ProBookings" padded pro>
        <div className="pro-header">Manage Your Bookings</div>

        <ProBookableSlots />
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    errors: state.errors,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProBookings);



/** WEBPACK FOOTER **
 ** ./src/components/ProBookings.js
 **/